const partnerRoles = [
  'ROLE_EXTERNAL_REQUESTER',
  'ROLE_EXTERNAL_PARTNER_ADMIN',
]

const rolesAllowedToAssignPartnerRoles = [
  'ROLE_USER_MANAGEMENT',
  'ROLE_ADMIN',
  'ROLE_SUPER_ADMIN',
  'ROLE_HR_MANAGER',
]

const roleTranslationKeyPrefix = 'roles.'

const resolveRoleLabel = (role, translate, hasTranslation) => {
  if (typeof translate !== 'function') {
    return role
  }

  const translationKey = `${roleTranslationKeyPrefix}${role}`

  if (typeof hasTranslation === 'function' && !hasTranslation(translationKey)) {
    return role
  }

  return translate(translationKey)
}

export const canAssignPartnerRoles = currentUserRoles => {
  const roles = Array.isArray(currentUserRoles) ? currentUserRoles : []

  return rolesAllowedToAssignPartnerRoles.some(role => roles.includes(role))
}

export const sortRolesByTranslation = (rolesToSort, translate, hasTranslation) => [...rolesToSort]
  .sort((leftRole, rightRole) => resolveRoleLabel(leftRole, translate, hasTranslation)
    .localeCompare(resolveRoleLabel(rightRole, translate, hasTranslation), undefined, { sensitivity: 'base' }))

export const extendAssignableRoles = currentUserRoles => {
  const roles = Array.isArray(currentUserRoles) ? currentUserRoles : []
  if (!canAssignPartnerRoles(roles)) {
    return roles
  }

  return [...new Set([...roles, ...partnerRoles])]
}
